const defaultRender = (value) => (value ? value : '--');

const columns = [
    {
        title: 'File Name',
        dataIndex: 'files',
        render: (_, record) => record?.files?.service_name_slug ? record?.files?.service_name_slug : '--'
    },
    {
        title: 'File Number',
        dataIndex: 'files',
        render: (_, record) => record?.files?.file_number ? record?.files?.file_number : '--'
    },
    {
        title: 'Status',
        dataIndex: 'status',
        render: defaultRender,
    },
    {
        title: 'Amount',
        dataIndex: 'amount',
        render: defaultRender,
    },
    {
        title: 'Action',
        dataIndex: 'action',
        render: defaultRender,
    },
];

export default columns;